import React from 'react';
import { BatchSimulationSummary } from '../../lib/batchTaxSimulatorEngine';

export interface BatchSimulatorKpiCardsProps {
  summary: BatchSimulationSummary;
  formatBRL: (val: number) => string;
  formatPct: (val: number) => string;
}

export default function BatchSimulatorKpiCards({
  summary,
  formatBRL,
  formatPct,
}: BatchSimulatorKpiCardsProps) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
      {/* Card 1: Total de Itens */}
      <div className="p-4 bg-white rounded-2xl border border-slate-200 shadow-xs">
        <span className="text-[11px] font-bold text-slate-500 uppercase tracking-wider block mb-1">
          Total de Itens
        </span>
        <div className="text-2xl sm:text-3xl font-black text-slate-900">
          {summary.totalItems}
        </div>
        <span className="text-[10px] text-slate-400 mt-0.5 block">Produtos NCM & Serviços NBS</span>
      </div>

      {/* Card 2: Créditos da Reforma (Notas de Entrada) */}
      <div className="p-4 bg-white rounded-2xl border border-slate-200 shadow-xs">
        <div className="flex items-center justify-between mb-1">
          <span className="text-[11px] font-bold text-slate-500 uppercase tracking-wider block">
            Créditos Recuperados
          </span>
          {(summary.totalConsumptionCreditsGained || 0) > 0 && (
            <span className="text-[9px] font-black text-emerald-800 bg-emerald-100 px-1.5 py-0.5 rounded-full" title="Créditos em materiais de uso e consumo (ganho inédito da Reforma Tributária)">
              +{formatBRL(summary.totalConsumptionCreditsGained)} Consumo
            </span>
          )}
        </div>
        <div className="text-2xl sm:text-3xl font-black text-emerald-700">
          {formatBRL(summary.totalInputCreditsGained)}
        </div>
        <span className="text-[10px] text-emerald-800 mt-0.5 block font-mono">
          CBS: +{formatBRL(summary.totalCbsCreditGained)} | IBS: +{formatBRL(summary.totalIbsCreditGained)}
        </span>
      </div>

      {/* Card 3: Débitos da Nova Reforma (Notas de Saída) */}
      <div className="p-4 bg-white rounded-2xl border border-slate-200 shadow-xs">
        <span className="text-[11px] font-bold text-slate-500 uppercase tracking-wider block mb-1">
          Débitos da Nova Reforma
        </span>
        <div className="text-2xl sm:text-3xl font-black text-rose-700">
          {formatBRL(summary.totalTaxOnSale)}
        </div>
        <span className="text-[10px] text-rose-800 mt-0.5 block font-mono">
          CBS: {formatBRL(summary.totalCbsDebitOnSale)} | IBS: {formatBRL(summary.totalIbsDebitOnSale)}
        </span>
      </div>

      {/* Card 4: Margem Média Projetada e Saldo a Recolher */}
      <div className="p-4 bg-white rounded-2xl border border-slate-200 shadow-xs">
        <span className="text-[11px] font-bold text-slate-500 uppercase tracking-wider block mb-1">
          Margem Média Projetada
        </span>
        <div className="text-2xl sm:text-3xl font-black text-slate-900">
          {formatPct(summary.averageProjectedMarginPct)}
        </div>
        <span className="text-[10px] text-slate-400 mt-0.5 block">
          Saldo a recolher: {formatBRL(summary.totalNetTaxPayable)}
        </span>
      </div>
    </div>
  );
}
